import {BaseElement} from "../BaseElement";

export class MultipleSwitch {
    #rootElement;
    #buttonsName;
    #isWithLabels;
    #handlerFunction;
    #defaultCheckedId;

    constructor({buttonsDictionary, changeHandlerFunction, buttonsName, defaultCheckedId, isWithLabels = false}) {
        this.#rootElement = new BaseElement('fieldset')
            .addClass('multiple-switch');

        this.#buttonsName = buttonsName;
        this.#isWithLabels = isWithLabels;
        this.#handlerFunction = changeHandlerFunction;
        this.#defaultCheckedId = defaultCheckedId;

        buttonsDictionary.forEach(buttonData => {
            this.#radioButton(buttonData);
        });

    }

    get rootElement() {
        return this.#rootElement;
    }

    setState(elementId) {
        const targetElement = document.getElementById(elementId);
        targetElement.checked = true;
    }

    #radioButton(buttonData) {
        const wrapperElement = new BaseElement()
            .appendTo(this.#rootElement);

        const radioButton = new BaseElement('input')
            .addClass('multiple-switch__radio-button')
            .setAttributes({
                'type': 'radio',
                'id': this.#buttonsName + '_' + buttonData.id,
                'name': this.#buttonsName,
                'value': buttonData.value
            })
            .event('change', this.#handlerFunction)
            .appendTo(wrapperElement);

        if (buttonData.id === this.#defaultCheckedId)
            radioButton.DOMElement.checked = true;

        new BaseElement('icon')
            .addClass('multiple-switch__radio-icon', buttonData.icon)
            .appendTo(wrapperElement);

        if (this.#isWithLabels) {
            new BaseElement('label')
                .addAttribute('for', buttonData.id)
                .innerHtml(buttonData.value)
                .appendTo(wrapperElement);
        }
    }
}